var tocBstackJS = (function () {
  return {
    init: init,
  };

  function init() {
    uiBindings();

    // init accordions
    var accordions = document.querySelectorAll('.bstack-toc__accordion');
    accordions.forEach(function(accordion) {
      var intro = accordion.querySelector(".bstack-toc__accordion-trigger");
      
      if (intro) {
        intro.addEventListener("click", function () {
          var that = this;
          if (accordion.classList.contains("bstack-toc__accordion--active")) {
            closeAccordion(that, accordion);
          } else {
            accordions.forEach(function(accordion) { 
              closeAccordion(that, accordion);
            });
            openAccordion(that, accordion);
          }
        });
      }
    });

    //Click element
    var tocLinks = document.querySelectorAll('.bstack-toc__accordion-content a'),
    boolTocClick = false;
    for (var i = 0; i < tocLinks.length; i++) {
      tocLinks[i].addEventListener("click", function () {
        var that = this;

        boolTocClick = true;
        for (var j = 0; j < tocLinks.length; j++) {
          if (that == tocLinks[j]) {
            tocLinks[j].classList.add("active");
          } else {
            tocLinks[j].classList.remove("active");
          }
        }

        //wait for smooth scroll 1000 ms
        setTimeout(function () {
          boolTocClick = false;
        }, 1000);
      });
    }

    window.addEventListener('scroll', function() {
      var sidebar = document.getElementById('microsite-templ-sidebar-abs');
      if (!boolTocClick && sidebar && window.innerWidth > 979) {
        var allToc = document.querySelectorAll("#microsite-templ-sidebar-abs .bstack-toc__accordion-content a"),
        activeToc = document.querySelector("#microsite-templ-sidebar-abs .bstack-toc__accordion-content a.active"),
        activeIndex = 0;

        if (allToc.length > 0) {
          for (var j = 0; j < allToc.length; j++) {
            var tocID = allToc[j].getAttribute("href"),
            tocDom = document.querySelector(tocID);

            if (tocDom) {
              var tocDomRect = tocDom.getBoundingClientRect();
              if ((tocDomRect.top - 84) < 0) {
                activeIndex = j;
              }
            }
          }

          activeToc.classList.remove("active");
          allToc[activeIndex].classList.add("active");
        }
      }
    });
  }

  function uiBindings() {
    var parentHeading = document.querySelector('.microsite-templ-main-content'),
      parentBlock = document.querySelector('.bstack-toc__list'),
      tocBlock = document.querySelector('.bstack-toc'),
      allHeading = parentHeading.querySelectorAll(
        'h2:not(.hide-toc-heading), h3:not(.hide-toc-heading)'
      );

    if (!tocBlock) {
      return false;
    }

    // retrun if heading list is less than 3
    if (allHeading.length < 2) {
      tocBlock.remove();
      return false;
    }

    for (var i = 0, j = 0; i < allHeading.length; i++) {
      var ele = allHeading[i];
      
      if (ele.closest(".bstack-callout__heading, .microsite-templ-faq")) {
        continue;
      }

      var clearInnerHeading = ele.innerHTML.replace(/\n|<.*?>/g, '');
      if (ele.nodeName == 'H2' || ele.nodeName == 'H3') {
        if (clearInnerHeading) {
          ele.setAttribute('id', 'toc' + j);
          j++;
        }
      }
    }

    // Remove unwanted anchor tag
    var anchors = parentBlock.getElementsByTagName('a');
    for (var i = 0; i < anchors.length; i++) {
      var anchor = anchors[i];
      if (anchor.innerHTML == '') {
        anchor.parentNode.removeChild(anchor); //removes the anchor
      }
    }
  }

  function openAccordion(that, accordion) {
    accordion.classList.add("bstack-toc__accordion--active");
    that.setAttribute('aria-expanded', 'true');
  }
  
  function closeAccordion(that, accordion) {
    accordion.classList.remove("bstack-toc__accordion--active");
    that.setAttribute('aria-expanded', 'false');
  }
})();

tocBstackJS.init();
